'use client';

import { forwardRef, useCallback } from 'react';
import Link from 'next/link';
import { useTranslation } from '@weareconceptstudio/core';
import { useFulfillmentCartGuard } from '@/hooks/useFulfillmentCartGuard';
import { isCartOrCheckoutUrl } from '@/helpers/fulfillmentGuard';

const CustomLink = forwardRef(
	(
		{
			url,
			className = '',
			prefetch = true,
			scroll = true,
			replace = false,
			external = false,
			onClick,
			...props
		},
		ref
	) => {
		const { translate, selectedLang } = useTranslation();
		const { blockNavigation } = useFulfillmentCartGuard();

		const handleClick = useCallback(
			(event) => {
				if (!external && isCartOrCheckoutUrl(url) && blockNavigation(event, url)) return;
				onClick?.(event);
			},
			[blockNavigation, external, onClick, url]
		);

		const href =
			typeof url === 'object'
				? { ...url, pathname: external ? url.pathname : `/${selectedLang}${url.pathname}` }
				: external
					? url
					: `/${selectedLang}${url}`;
		const ariaLabel = translate(
			props.text?.replaceAll('/') ||
				props.ariaLabel ||
				(typeof url === 'object' ? url.pathname?.replaceAll('/', '') : url?.replaceAll('/', ''))
		);

		return (
			<Link
				href={href}
				scroll={scroll}
				replace={replace}
				prefetch={prefetch}
				legacyBehavior>
				<a
					ref={ref}
					className={`link-item ${className}`}
					rel={external ? 'noopener noreferrer' : undefined}
					target={external ? '_blank' : props.target || '_self'}
					aria-label={ariaLabel}
					onClick={handleClick}>
					{props.children || (props.content ? translate(props.content) : null)}
				</a>
			</Link>
		);
	}
);

export default CustomLink;
